<template>
  <UserTransactionDetail />
</template>
<script>
import appConfig from '@/app.config'

import UserTransactionDetail from '../../../components/dadban/wallet/UserTransactionDetail.vue'

export default {
  page: {
    title: 'تراکنش های کاربر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'userTransactionDetail',
  components: {
    UserTransactionDetail,
  },
}
</script>
